import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer outline">
      <div className="copyrights">
        <span>{new Date().getFullYear()} © Все права защищены</span>
      </div>
    </footer>
  );
}

export default Footer;